import MetaLogoLight from '../assets/images/publishers/meta-logo-light.png';
import MetaLogoDark from '../assets/images/publishers/meta-logo-dark.png';

import GoogleLogo from '../assets/images/publishers/google-logo.png';
import TwitterLogo from '../assets/images/publishers/twitter-logo.png';
import LinkedInLogo from '../assets/images/publishers/linkedin-logo.png';
import TikTokLogo from '../assets/images/publishers/tiktok-logo.png';

export const logos = {
    Meta: {
        light: MetaLogoLight,
        dark: MetaLogoDark,
    },
    Google: {
        light: GoogleLogo,
        dark: GoogleLogo,
    },
    Twitter: {
        light: TwitterLogo,
        dark: TwitterLogo,
    },
    LinkedIn: {
        light: LinkedInLogo,
        dark: LinkedInLogo,
    },
    TikTok: {
        light: TikTokLogo,
        dark: TikTokLogo,
    },
}